export default __webpack_public_path__ + "static/media/computer.85b3b87e.png";